/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdVerificationRequestDto
 */
export interface IdVerificationRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof IdVerificationRequestDto
     */
    workflowInstanceId: string;
    /**
     * Workflow task actor id that is used for this operation
     * @type {string}
     * @memberof IdVerificationRequestDto
     */
    workflowInstanceAssignedTaskId?: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof IdVerificationRequestDto
     */
    orgId?: string;
    /**
     * Country code of user's telephone number
     * @type {string}
     * @memberof IdVerificationRequestDto
     */
    countryCode: string;
    /**
     * User's telephone number without country code
     * @type {string}
     * @memberof IdVerificationRequestDto
     */
    phoneNumber: string;
}

/**
 * Check if a given object implements the IdVerificationRequestDto interface.
 */
export function instanceOfIdVerificationRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    if (!('countryCode' in value)) return false;
    if (!('phoneNumber' in value)) return false;
    return true;
}

export function IdVerificationRequestDtoFromJSON(json: any): IdVerificationRequestDto {
    return IdVerificationRequestDtoFromJSONTyped(json, false);
}

export function IdVerificationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdVerificationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'workflowInstanceAssignedTaskId': json['workflowInstanceAssignedTaskId'] == null ? undefined : json['workflowInstanceAssignedTaskId'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'countryCode': json['countryCode'],
        'phoneNumber': json['phoneNumber'],
    };
}

export function IdVerificationRequestDtoToJSON(value?: IdVerificationRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'workflowInstanceAssignedTaskId': value['workflowInstanceAssignedTaskId'],
        'orgId': value['orgId'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
    };
}

